document.addEventListener('DOMContentLoaded', function () {
    const productGrid = document.getElementById('product-grid');
    const loadMore = document.getElementById('load-more');
    let isLoading = false;

    const loadNextPage = () => {
        if (isLoading || !loadMore.dataset.nextPage) return;
        isLoading = true;

        fetch(loadMore.dataset.nextPage)
            .then((response) => response.text())
            .then((html) => {
                // Créer un élément temporaire pour extraire le contenu
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');

                // Ajouter les nouveaux produits
                const newProducts = doc.querySelectorAll('.collection-item');
                newProducts.forEach((item) => productGrid.appendChild(item));

                // Mettre à jour l'URL de la prochaine page
                const newNextPage = doc.querySelector('#load-more').dataset.nextPage;
                if (newNextPage) {
                    loadMore.dataset.nextPage = newNextPage;
                } else {
                    loadMore.dataset.nextPage = ''; // Pas de page suivante
                }

                isLoading = false;
            })
            .catch((error) => {
                console.error('Erreur lors du chargement des produits :', error);
                isLoading = false;
            });
    };

    const scrollTrigger = document.getElementById('bottom-collection-trigger');
  
    const handleScroll = () => {
        const scrollPosition = window.scrollY + window.innerHeight;
        const triggerPosition = scrollTrigger.offsetTop;
      
        if (scrollPosition >= triggerPosition - 100) {
            loadNextPage();
        }
    };

    window.addEventListener('scroll', handleScroll);
});






function filterCheck() {
    var option_name = '';
    var length = $('.filter-item-checkbox:checked').length;
    var sort = $('#sort_by option:selected').val();
    var coll = $('.collection_name').val();

    var min_price = $('#min_price').val();
    var max_price = $('#max_price').val();

    // Défaut à "all" si aucune collection n'est spécifiée
    coll = coll === 'products' ? 'all' : coll;

    // Construire la chaîne de prix uniquement si les valeurs sont valides
    var prices = '';
    if (min_price && max_price) {
        prices = 'filter.v.price.gte=' + encodeURIComponent(min_price) + 
                 '&filter.v.price.lte=' + encodeURIComponent(max_price);
    }

    // Construire la chaîne des options de filtre
    $(".filter-item-checkbox:checked").each(function(index, element) {
        option_name += $(this).data('option') + '=' + encodeURIComponent($(this).val());
        if (index !== length - 1) {
            option_name += '&';
        }
    });

    // Mettre à jour le compteur de filtres
    $('.added_filter').text(length);

    // Générer l'URL proprement
    var url = '/collections/' + coll + '?';
    if (option_name) {
        url += option_name + '&';
    }
    if (prices) {
        url += prices + '&';
    }
    url += 'sort_by=' + encodeURIComponent(sort);

    // Supprimer les éventuels '&' en trop à la fin
    url = url.replace(/&$/, '');

    // Mettre à jour l'historique et les produits
    window.history.pushState({}, null, url);
    filter_update(url);
}

function filter_update(url) {
    fetch(url)
        .then(response => response.text())
        .then(infoData => {
            var products = $(infoData);
            var items = $('.collection-product-wrap', products);
            $('.collection-product-wrap').replaceWith(items);
        });
}
